import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICloudReceiverModel } from '@apps-common/types/portal/cloud-receiver'

export const getCloudReceivers = async (): Promise<ICloudReceiverModel> =>
  axios.get('/CloudReceiver/GetCloudReceivers').then((res) => res.data?.data)

type QueryFnType = typeof getCloudReceivers

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetCloudReceivers = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getCloudReceivers'],
    queryFn: () => getCloudReceivers()
  })
